import { getPropertyByKeyPath } from '@shared/utils/object.util';

export function sortFieldsOnTable(dataTable, e) {
  const keyword = e.key;
  const [...newData] = dataTable;

  if (keyword.split('.').length) {
    return newData.sort(
      (a, b) => {
        let key1 = getPropertyByKeyPath(a, keyword);
        let key2 = getPropertyByKeyPath(b, keyword);
        if (typeof key1 === 'string') {
          key1 = key1.toLowerCase();
          key2 = key2.toLowerCase();
          if (key1.includes('/')) {
            const [day, month, year] = key1.split('/');
            const aVal = new Date(+year, +month - 1, +day).getTime();
            const [day1, month1, year1] = key2.split('/');
            const bVal = new Date(+year1, +month1 - 1, +day1).getTime();
            return (e.value === 'ascend') ? (aVal > bVal ? 1 : -1) : (bVal > aVal ? 1 : -1);
          }
          if (key1.includes('-')) {
            const [year, month,day ] = key1.split('-');
            const aVal = new Date(+year, +month - 1, +day).getTime();
            const [year1, month1, day1] = key2.split('-');
            const bVal = new Date(+year1, +month1 - 1, +day1).getTime();
            return (e.value === 'ascend') ? (aVal > bVal ? 1 : -1) : (bVal > aVal ? 1 : -1);
          }
        }

        return (e.value === 'ascend') ? (key1 > key2 ? 1 : -1) : (key2 > key1 ? 1 : -1);
      });
  } else {
    return newData.sort(
      (a, b) => (e.value === 'ascend') ? (a[e.key] > b[e.key] ? 1 : -1) : (b[e.key] > a[e.key] ? 1 : -1)
    );
  }
}

export function separateDisabledUsers(data) {
  const enabledUsers = data.filter(item => item.enabled);

  const disabledUsers = data.filter(item => !item.enabled);

  return [
    ...enabledUsers,
    ...disabledUsers
  ];
}

export const sortArrayAlphabetically = (data, key) =>
  data.sort((a, b) => a[key].toLowerCase() < b[key].toLowerCase() ? -1 : 1);

export const sortArrayAlphabeticallyDevelopers = (data, key) =>
data.sort((a, b) => a[key].toLowerCase().localeCompare < b[key].toLowerCase().localeCompare ? -1 : 1);

export const sortArrayNumerically = (data, key) =>
  data.sort((a, b) => b[key] - a[key]);
